// libs
import { styled } from '@nykaa/ui-components';

//constants
import { BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const PriceRevealContainer = styled.div`
  position: relative;
  ${({ theme }) => `
    padding: 0 0 0 ${theme.spacing.spacing40};
    margin-top: ${theme.spacing.spacing20};
  `};
`;

export const Pipe = styled.div<{ color: string }>`
  position: absolute;
  left: 0;
  height: 23px;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    height: 36px;
    top: 0;
  }
  ${({ color }) =>
    color &&
    `
    background : ${color};
  `}
  ${({ theme }) => `
    border-radius: ${theme.spacing.spacing10};
    top: ${theme.spacing.spacing10};
    width: ${theme.spacing.spacing10};
  `};
`;

export const Amount = styled.span<{ color: string }>`
  ${({ color }) =>
    color &&
    `
    color: ${color};
  `};
  ${({ theme }) => theme.typography.subTitleSmall};
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.buttonMedium};
  }
`;

export const Text = styled.span<{ color: string }>`
  ${({ color }) =>
    color &&
    `
    color: ${color};
  `};
  ${({ theme }) => theme.typography.bodyXSmall};
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodySmall};
  }
`;

export const Title = styled.div`
  width: 100%;
  max-width: max-content;
  ${({ theme }) => `
    line-height: ${theme.spacing.spacing60};
  `};
`;

export const Discount = styled.span<{ color: string }>`
  ${({ color }) =>
    color &&
    `
    color: ${color};
  `};
  ${({ theme }) => `
    margin-left: ${theme.spacing.spacing20};
  `};
  ${({ theme }) => theme.typography.bodyXSmall};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodySmall};
  }
`;
